export default {
  default: () => import("E:/New/aski-pwa-app-code/aski-pwa-app-code/aski-pwa-app-code/layouts/default.vue").then(m => m.default || m),
  empty: () => import("E:/New/aski-pwa-app-code/aski-pwa-app-code/aski-pwa-app-code/layouts/empty.vue").then(m => m.default || m),
  guest: () => import("E:/New/aski-pwa-app-code/aski-pwa-app-code/aski-pwa-app-code/layouts/guest.vue").then(m => m.default || m)
}